import { useDispatch } from "react-redux";
import {
  addToExcluded,
  removeFromExcluded,
} from "../redux/reducers/billableItems.reducer";

// Shared by Milestones/Recurring/Resources (BillableItemsResultsPage): each
// row's checkbox toggles in/out of the "excluded" list for its own
// billable-item type.
export const useBillableItemsRowSelection = (
  type: "milestones" | "recurring" | "resources",
  excluded: any[]
) => {
  const dispatch = useDispatch();

  const isSelected = (id: number) => {
    return !excluded.some((item: any) => item.id === id);
  };

  const onClickCheckbox = (item: any) => {
    if (isSelected(item.id)) {
      dispatch(
        addToExcluded({
          type,
          id: item.id,
        })
      );
    } else {
      dispatch(
        removeFromExcluded({
          type,
          id: item.id,
        })
      );
    }
  };

  return { isSelected, onClickCheckbox };
};
